import { render, staticRenderFns } from "./SeriesDetails.vue?vue&type=template&id=cc1e398e&scoped=true&"
import script from "./SeriesDetails.vue?vue&type=script&lang=js&"
export * from "./SeriesDetails.vue?vue&type=script&lang=js&"
import style0 from "./SeriesDetails.vue?vue&type=style&index=0&id=cc1e398e&prod&scoped=true&lang=css&"
import style1 from "./SeriesDetails.vue?vue&type=style&index=1&id=cc1e398e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1e398e",
  null
  
)

export default component.exports